import { useQuery } from "@tanstack/react-query";
import type { ApiResponse } from "../../../types/apiResponse";
import type { ProviderData } from "../types";
import withPrefix from "../../../helpers/useQueryPrefix";
import { fetchProviders } from "../api/fetchProviders";


export const useFetchProviders = () => {
	return useQuery<ApiResponse<ProviderData[]>, Error, ProviderData[]>({
		queryKey: withPrefix(['providers']),
		queryFn: fetchProviders,
		select: (response) => {
			if (response.status !== 200) {
				throw new Error(response.message);
			}
			return response.data as ProviderData[];
		},
	})

};
